import React, { useCallback, useState } from 'react';

import { Card, CheckboxInput, Input, InputGroup, Select } from '@nearst/ui';
import { updateChannel } from '@services/channels';

import styles from './WidgetSettings.module.scss';

const defaultValues = {
	cta: 'shop_nearby',
	showCount: true,
	distanceCutoff: 200,
	lowStockThreshold: 3,
	noResultsMessage: 'No nearby stores currently have this product in stock.'
};

const WidgetSettings = ({ channel }) => {
	const [values, setValues] = useState({
		...defaultValues,
		...(channel?.config || {})
	});

	let labelPreview = `${values.cta === 'shop_nearby' ? 'Shop nearby' : 'Pick up today'}`;
	if (values.showCount) labelPreview += ` (9 stores)`;

	const update = useCallback(
		(e) => {
			let newValue = e.target.value;
			if (e.target.type === 'number') newValue = Number(newValue);
			if (e.target.type === 'checkbox') newValue = e.target.checked;

			setValues((prev) => ({
				...prev,
				[e.target.id]: newValue
			}));

			updateChannel(undefined, channel.type, {
				[e.target.id]: newValue
			});
		},
		[channel, setValues]
	);

	return (
		<Card
			title="Widget customization"
			description="Customize the appearance of your Product Locator widget."
			className={styles.container}
		>
			<InputGroup label="Button label" htmlFor="cta">
				<Select id="cta" defaultValue={values.cta} onChange={update}>
					<option value="shop_nearby">Shop nearby</option>
					<option value="pick_up">Pick up today</option>
				</Select>
				<div className={styles.buttonLabelCheckbox}>
					<CheckboxInput id="showCount" label="Show store count on button" defaultChecked={values.showCount} onChange={update} />
					<div className={styles.buttonLabelPreview}>Label shown: {labelPreview}</div>
				</div>
			</InputGroup>

			<InputGroup label="Maximum distance to show stores" htmlFor="distanceCutoff" className={styles.distanceCutoff}>
				<Input
					id="distanceCutoff"
					placeholder="200"
					suffix="km"
					type="number"
					defaultValue={values.distanceCutoff}
					onBlur={update}
				/>
			</InputGroup>

			<InputGroup label="Stock status" htmlFor="lowStockThreshold">
				<CheckboxInput
					label={`Display 'Low stock' tag ${values.lowStockThreshold > 0 ? 'if quantity under' : ''}`}
					checked={values.lowStockThreshold > 0}
					onChange={(e) => update({ target: { id: 'lowStockThreshold', value: e.target.checked ? 3 : 0 } })}
				/>
				{values.lowStockThreshold > 0 && (
					<Input
						containerClassName={styles.quantityThreshold}
						id="lowStockThreshold"
						placeholder="3"
						type="number"
						defaultValue={values.lowStockThreshold}
						onBlur={update}
					/>
				)}
			</InputGroup>

			<InputGroup label='"No stock found" message' htmlFor="noResultsMessage" className={styles.noResultsMessage}>
				<Input id="noResultsMessage" type="text" defaultValue={values.noResultsMessage} onBlur={update} />
			</InputGroup>
		</Card>
	);
};

export default WidgetSettings;
